function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105.16 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.17 37.16h83.48a8.4 8.4 0 0 1 2 .16 5.93 5.93 0 0 1 2.88 1.56 5.43 5.43 0 0 1 1.64 3.34 7.65 7.65 0 0 1-.06 1.44L94 117.31v.41a7.06 7.06 0 0 1-.2.9v.06a5.89 5.89 0 0 1-5.47 4.07H17.32a6.17 6.17 0 0 1-1.25-.19 6.17 6.17 0 0 1-1.16-.48 6.18 6.18 0 0 1-3.08-4.88l-7-73.49a7.69 7.69 0 0 1-.06-1.66 5.37 5.37 0 0 1 1.63-3.29 6 6 0 0 1 3-1.58 8.94 8.94 0 0 1 1.79-.13ZM5.65 8.8h31.47V6a2.44 2.44 0 0 1 0-.27 6 6 0 0 1 1.76-4A6 6 0 0 1 43.09 0h19.67a6 6 0 0 1 5.7 6v2.8h32.39a4.7 4.7 0 0 1 4.31 4.43v10.36a2.59 2.59 0 0 1-2.59 2.59H2.59A2.59 2.59 0 0 1 0 23.62V13.53a1.56 1.56 0 0 1 0-.31 4.72 4.72 0 0 1 3.88-4.34 10.4 10.4 0 0 1 1.77-.08Zm42.1 52.7a4.77 4.77 0 0 1 9.49 0v37a4.77 4.77 0 0 1-9.49 0v-37Zm23.73-.2a4.58 4.58 0 0 1 5-4.06 4.47 4.47 0 0 1 4.51 4.46l-2 37a4.57 4.57 0 0 1-5 4.06 4.47 4.47 0 0 1-4.51-4.46l2-37ZM25 61.7a4.46 4.46 0 0 1 4.5-4.46 4.58 4.58 0 0 1 5 4.06l2 37a4.47 4.47 0 0 1-4.51 4.46 4.57 4.57 0 0 1-5-4.06l-2-37Z",
    style: {
      fillRule: "evenodd"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default ForwardRef;